import I18n from 'I18n';
import { MALFORMED_EMAIL, PREVIOUSLY_BOUNCED, MISSING_PERMISSION } from 'composer-data/email/public/constants';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { InfoIcon, WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getToolTipString = (identifierValue, validationData, isEmailLoggingBlocked) => {
  if (validationData && !validationData.isValid) {
    if (validationData.reason === MALFORMED_EMAIL) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.invalid-email', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === PREVIOUSLY_BOUNCED) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.bounced-contact', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === MISSING_PERMISSION) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.permissions', {
        recipientEmail: identifierValue
      });
    } else if (validationData.reason === 'WHATSAPP_NOT_OPTED_IN') {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.whatsapp-subscription');
    }
  } else if (isEmailLoggingBlocked) {
    return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.never-log', {
      recipientEmail: identifierValue
    });
  }
  return identifierValue;
};
const GenericRecipientTag = ({
  option: {
    name,
    address,
    value,
    validationData,
    isEmailLoggingBlocked
  }
}) => {
  const tagTextContent = name || address || value;
  const title = getToolTipString(address || value, validationData, isEmailLoggingBlocked);
  const isInvalid = validationData && !validationData.isValid;
  return /*#__PURE__*/_jsx(Tooltip, {
    display: "inline-block",
    title: title,
    children: /*#__PURE__*/_jsxs("span", {
      children: [tagTextContent, isInvalid || isEmailLoggingBlocked ? /*#__PURE__*/_jsx(IconHolder, {
        icon: isEmailLoggingBlocked ? InfoIcon : WarningIcon,
        padding: "0",
        size: "100"
      }) : null]
    })
  });
};
GenericRecipientTag.displayName = 'GenericRecipientTag';
export default GenericRecipientTag;